
import React from 'react';
import { mdx } from '@mdx-js/react';


export const frontMatter = {
	id: 'select-events',
	title: 'Selecting relevant policy events'
};
export const contentTitle = undefined;
export const metadata = {
  "unversionedId": "webhooks/select-events",
  "id": "webhooks/select-events",
  "isDocsHomePage": false,
  "title": "Selecting relevant policy events",
  "description": "Select Events",
  "source": "@site/docs/webhooks/select-events.md",
  "sourceDirName": "webhooks",
  "slug": "/webhooks/select-events",
  "permalink": "/docs/webhooks/select-events",
  "tags": [],
  "version": "current",
  "frontMatter": {
    "id": "select-events",
    "title": "Selecting relevant policy events"
  },
  "sidebar": "docs",
  "previous": {
    "title": "Connecting to a Policy Service",
    "permalink": "/docs/getting-started/connecting-to-a-policy-service"
  },
  "next": {
    "title": "Setting up an action",
    "permalink": "/docs/webhooks/setup-an-action"
  }
};


/* @jsxRuntime classic */
/* @jsx mdx */

export const toc = [];

const layoutProps = {
  toc
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p><img alt={"Select Events"} src={require("!url-loader?limit=10000&name=assets/images/[name]-[hash].[ext]&fallback=file-loader!./select-events.png").default} /></p>
    <p>{`Policy lifecycle events are grouped into categories that contain individual events. Each category contains multiple
individual events which can be configured with automation actions that are executed when the events are triggered.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
